import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "./ErrorPage.css";

const ErrorPage = () => {
  const navigate = useNavigate();

  const handleReturnClick = () => {
    navigate("/");
  };

  return (
    <div className="error-page">
      <div className="error-container">
        <h1 className="error-heading">Oops!</h1>
        <p className="error-text">Something went wrong.</p>
        <button className="return-button" onClick={handleReturnClick}>
          <FaArrowLeft className="return-icon" />
          Return to Home
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
